/*jshint esversion: 6 */
import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AuthService } from '../../services/authService';
import { UserMessageService } from '../../services/userMessageService';
import { WhiteLabelWhiteLabelAdminAPI } from '../../services/wladmin/whitelabelWhiteLabelAdminAPI';
import { PaymentWhiteLabelAdminAPI } from '../../services/wladmin/paymentWhiteLabelAdminAPI';

@inject(AuthService, Router, WhiteLabelWhiteLabelAdminAPI, PaymentWhiteLabelAdminAPI, UserMessageService)
export class WhiteLabel {
  constructor(authService, router, api, paymentAdminApi, userMessageService) {
    this.authService = authService;
    this.router = router;
    this.api = api;
    this.paymentAdminApi = paymentAdminApi;
    this.userMessageService = userMessageService;
  
    this.saving = false;
    this.loading = true;
    this.refreshAfterSave = false;
    this.id = null;
    this.resource_url = "";
    this.parentAppName = "Magnfi";
    this.wl_redirect_url = "";
    this.enable_white_label = false;
    this.enable_white_label_parent = false; // distinguishing whitelable, and whitelabel under whitelabel reseller
    this.is_vendasta_user = false;
    this.structureType = "1";
    this.monthlyLicenseFee = 0;
    this.amount = 0;
    this.type = 0;
  }

  activate(params) {
      console.log("PID:: ");
    this.loading = true;
    this.id = params.id ? params.id : this.authService.getUser().whitelabel_id;
    this.is_vendasta_user = this.authService.getUser().is_vendasta==1;
    this.whiteLabelData = this.authService.getWhitelabel();

    this.enable_white_label = this.whiteLabelData.enable_white_label_reseller ? this.whiteLabelData.enable_white_label_reseller : false;
    this.enable_white_label_parent = (this.whiteLabelData.parent_id == 0 && !this.whiteLabelData.enable_white_label_reseller) ? true : false;
    
    console.log("PID:: ", this.whiteLabelData.parent_id == 0, this.enable_white_label_parent);
    if(this.whiteLabelData) {
    this.parentAppName = this.whiteLabelData.parent_app_name == "" ? "Magnfi" : this.whiteLabelData.parent_app_name

    }
  
    
  }

  attached() {
    console.log('is',this.is_vendasta_user)
    this.paymentAdminApi.getPublicApiKey(this.authService.getUser().token, this.apiKeySuccess.bind(this), this.saveLoadError.bind(this), this.id);
  }

  apiKeySuccess(key) {
    this.renderStripe(key);
    this.load();
  
  }



  load() {
    this.api.getWhiteLabelData(
      this.authService.getUser().token,
      this.saveLoadSuccess.bind(this),
      this.saveLoadError.bind(this));
  }

  reset() {
    this.id = null;
    this.ownerUserId = null;
    this.businessName = null;
    this.billingAddress = null;
    this.contactFirstName = null;
    this.contactLastName = null;
    this.contactEmail = null;
    this.contactPhone = null;
    this.domainName = null;
    this.whiteLabelStatus = null;
    this.last4 = null;
    this.support_email = null;
    this.emailSignatureHtml = null;
    this.emailSignatureText = null;
    this.emailRequestBottomHtml = null;
    this.emailRequestBottomText = null;
    this.appName = null;
    this.siteTitle = null;
    this.homeURL = null;
    this.footerHtml = null;
    this.paymentIntData = null;
    this.tutorialURL = null;
    this.privacyURL = null;
    this.tosURL = null;
    this.youtubeApiClientId = null;
    this.youtubeApiClientSecret = null;
    this.plus_monthly_fee = null;
    this.enable_plus_val = true;
    this.disable_pay_per_video_val = true;
    this.private_label = false;

    this.imgType = 'site_logo';
    this.files = new Map();
  }

  save() {
    if (this.validate()) {
      this.saving = true;

      if(this.last4 == null) {
        
        this.stripe.createToken(this.card, { name: this.cardholderName }).then(function (result) {
          if (result.error) {
            // Inform the user if there was an error
            this.saving = false;
            this.displayError.textContent = result.error.message;
          } else {
            // Send the token to your server
            this.api.save(
              this.getData(result.token.id),
              this.files,
              this.authService.getUser().token,
              this.saveLoadSuccess.bind(this),
              this.saveLoadError.bind(this));
          }
        }.bind(this));
      } else {
        this.api.save(
          this.getData(),
          this.files,
          this.authService.getUser().token,
          this.saveLoadSuccess.bind(this),
          this.saveLoadError.bind(this));
      }
   
    }
  }



  saveLoadSuccess(data) {
    this.loading = false;
    this.setData(data);

    if (this.saving) {
      this.userMessageService.setUserMessage('user', 'Saved!');
      
    }

    if(this.refreshAfterSave) {
      setTimeout(() => {location.reload();}, 2000);
    }

    this.saving = false;

    
  }

  saveLoadError(msg) {
    this.userMessageService.setUserError('user', msg);
    this.loading = false;
    this.saving = false;
  }

  setData(data) {
    console.log("WL Admin Data: ");
    console.log(data);
    this.id = data.id;
    this.ownerUserId = data.owner_user_id;
    this.businessName = data.business_name;
    this.billingAddress = data.billing_addr;
    this.contactFirstName = data.contact_first_name;
    this.contactLastName = data.contact_last_name;
    this.contactEmail = data.contact_email;
    this.contactPhone = data.contact_phone;
    this.domainName = data.domain_name;
    this.whiteLabelStatus = data.status.toString();
    this.last4 = data.last4;
    this.support_email = data.support_email;
    this.emailSignatureHtml = data.email_signature_html;
    this.emailSignatureText = data.email_signature_text.replace(/\\n/g, '\n');
    this.emailRequestBottomHtml = data.email_request_bottom_html;
    this.emailRequestBottomText = data.email_request_bottom_text.replace(/\\n/g, '\n');
    this.appName = data.app_name;
    this.siteTitle = data.site_title;
    this.homeURL = data.home_url;
    this.footerHtml = data.footer_html;
    this.tutorialURL = data.tutorial_url;
    this.privacyURL = data.privacy_url;
    this.tosURL = data.tos_url;
    this.resource_url = data.resource_url? data.resource_url : "";
    this.wl_redirect_url = data.wl_redirect_url ? data.wl_redirect_url : "";
  
    this.paymentIntData = JSON.parse(data.payment_int_data);
    this.enable_plus_val = data.enable_plus;
    this.disable_pay_per_video_val = data.disable_pay_per_video!=null ? data.disable_pay_per_video : true;
    this.plus_monthly_fee = data.plus_monthly_fee;
    
    this.youtubeApiClientId = data.youtube_api_client_id;
    this.youtubeApiClientSecret = data.youtube_api_client_secret;
    this.private_label = data.private_label ? data.private_label : false;

    this.monthlyLicenseFee = data.monthly_fees != null ? data.monthly_fees:0;
    this.perVideoPrice = data.pay_per_video != null ? data.pay_per_video:0;
    this.plusPrice = data.plus_user != null ? data.plus_user:0;
    this.type = data.type != null ? data.type:0;
    this.structureType = this.type == 1? "1" : "0" ;
    
    this.imgType = 'site_logo';
    this.imgPath = 'api/whitelabel/getFile?file=' + this.imgType + '&t=' + new Date();
   
     this.showImageUpload = false;

     this.files = new Map();
  
     console.log("set private label: "+this.private_label);
     this.is_register_disabled = (data.is_register_disabled == 1) ? true : false;
  }

  imgTypeChanged() {
    this.imgPath = 'api/whitelabel/getFile?file=' + this.imgType + '&t=' + new Date();
    this.selected_images = null;
    this.showImageUpload = false;
    this.imageUploadText = '';
  }

  imgUpload() {
    this.files.set(this.imgType, this.selected_images[0]);

  }

  cssUpload() {
    this.files.set('site_css', this.selected_css[0]);
    this.refreshAfterSave = true;
  }



  getData(token = null) {
    var data = {
      'id': this.id,
      'owner_user_id': this.ownerUserId,
      'business_name': this.businessName,
      'billing_addr': this.billingAddress,
      'contact_first_name': this.contactFirstName,
      'contact_last_name': this.contactLastName,
      'contact_email': this.contactEmail,
      'contact_phone': this.contactPhone,
      'domain_name': this.domainName,
      'status': this.whiteLabelStatus,
      'support_email': this.support_email,
      'email_signature_html': this.emailSignatureHtml,
      'email_signature_text': this.emailSignatureText,
      'email_request_bottom_html': this.emailRequestBottomHtml,
      'email_request_bottom_text': this.emailRequestBottomText,
      'app_name': this.appName,
      'site_title': this.siteTitle,
      'home_url': this.homeURL,
      'footer_html': this.footerHtml,
      'tutorial_url': this.tutorialURL,
      'privacy_url': this.privacyURL,
      'tos_url': this.tosURL,
      'payment_int_data': JSON.stringify(this.paymentIntData),
      'payment_token': token,
      'enable_plus':  this.enable_plus_val,
      'disable_pay_per_video' : this.disable_pay_per_video_val,
      'plus_monthly_fee':  this.plus_monthly_fee,
      'youtube_api_client_id': this.youtubeApiClientId,
      'youtube_api_client_secret': this.youtubeApiClientSecret,
      'resource_url' : this.resource_url,
      'wl_redirect_url' : this.wl_redirect_url,
      'private_label' : this.private_label,
      "monthly_fees": this.monthlyLicenseFee, 
      "pay_per_video" : this.perVideoPrice,
      "plus_user" : this.plusPrice,
      "type" : this.type,
      "is_register_disabled": this.is_register_disabled
    };

    console.log("private label: "+this.private_label);
    return data;
  }

  renderStripe(key) {
    // Create a Stripe client
    this.stripe = Stripe(key);

    // Create an instance of Elements
    this.elements = this.stripe.elements();

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: '#32325d',
        lineHeight: '24px',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };

    // Create an instance of the card Element
    this.card = this.elements.create('card'/*, { style: style }*/);

    // Add an instance of the card Element into the `card-element` <div>
    this.card.mount('#card-element');

    // Handle real-time validation errors from the card Element.
    this.card.addEventListener('change', function (event) {

      if (event.error) {
        this.displayError.textContent = event.error.message;
      } else {
        this.displayError.textContent = '';
      }
    }.bind(this));
  }

  validate() {
    var pass = true;

    if (this.businessName === null || this.businessName.trim() == '' ) {
      this.userMessageService.setUserError('user', 'Business Name is empty');
      pass = false;
    }

    if (this.billingAddress === null || this.billingAddress.trim() == '' ) {
      this.userMessageService.setUserError('user', 'Billing Address is empty');
      pass = false;
    }

    if (this.contactEmail === null || this.contactEmail.trim() == '' ) {
      this.userMessageService.setUserError('user', 'Contact Email is empty');
      pass = false;
    }

    if (this.contactPhone === null || this.contactPhone.trim() == '' ) {
      this.userMessageService.setUserError('user', 'Contact Phone is empty');
      pass = false;
    }

    if (this.domainName === null || this.domainName.trim() == '' ) {
      this.userMessageService.setUserError('user', 'Domain Name is empty');
      pass = false;
    }

    return pass;
  }

  is_email(email) {
    var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    return emailReg.test(email);
  }


  payInvoices() {
    this.paymentAdminApi.processUnpaidInvoicePayments(
      this.authService.getUser().token,
      this.paymentSuccess.bind(this),
      this.saveLoadError.bind(this));
  }

  paymentSuccess() {
    this.userMessageService.setUserMessage('user', 'Invoice Payment successful!');
    setTimeout(() => {location.reload();}, 2000);
  }
}
